import React, { useState, useEffect } from 'react';
import  BugTable  from '../../components/FeedbackErrorCompnet/BugTable';
import  AddBugForm from '../../components/FeedbackErrorCompnet/AddBugForm';
import { getAllFbTracker, updateFbTracker, creaditFbTracker  } from '../../api/other/fbTracker';
import { Bug, CheckCircle, Clock, AlertCircle, Circle, Lightbulb, MessageSquare } from 'lucide-react';

import { useSelector } from 'react-redux';

function FeddbackErrorContainer() {
  const [bugs, setBugs] = useState([]);
  const [ideas, setIdeas] = useState([]);

  const [filterStatus, setFilterStatus] = useState('Activity');
  const [selectProject, setSelectProject] = useState('All Project');
  const [selectBranch, setSelectBranch] = useState('All Branch');

  const [activeTab, setActiveTab] = useState('feedback');
  const [searchContent, setSearchContent] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [hiddenStatus, setHiddenStatus] = useState(false);

  const [editingBug, setEditingBug] = useState(null);
  const [showTabWarning, setShowTabWarning] = useState(false);
  const [pendingTab, setPendingTab] = useState(null);
  const token = useSelector(state => state.token);
  const auth = useSelector(state => state.auth);
  const {  branchID } = auth.user;

  
  const handleTabChange = (newTab) => {
    // Only show warning if adding new bug (not editing) and modal is open with unsaved data
    if (!editingBug && showModal) {
      setShowTabWarning(true);
      setPendingTab(newTab);
    } else {
      setActiveTab(newTab);
      setShowModal(false);
      setEditingBug(null);
    }
  };

  useEffect(() => {
   // localStorage.setItem('bug-tracker-data', JSON.stringify(bugs));
   const logBug = async () => {
    try {
    //  const token = localStorage.getItem('token');
      const response = await getAllFbTracker(token);

      console.log("response.data", response.data);
      setBugs(response.data.data);
    } catch (error) {
      console.error('Error fetching bug tracker data:', error);
    }
  };

   // localStorage.setItem('bug-tracker-data', JSON.stringify(bugs));
   logBug();      
  }, []);

  const onSaveAddActivity = (bugId, activity) => {

  };

  const handleStatusChange = (id, newStatus) => {
    //

    const onChangeStatus = async () => {
      try {
        const dataToUpdate = { status: newStatus };
        const response = await updateFbTracker(id, 'status', dataToUpdate, token);
        console.log('Status update response:', response.data);

        setBugs(bugs.map(bug =>
          bug._id === id ? { ...bug, status: newStatus } : bug
        ));

      } catch (error) {
        console.error('Error updating status:', error);
      }
    };

    onChangeStatus();
  };

  const handleAddBug = (newBugData) => {
    if (editingBug) {
      // Update existing bug
      setBugs(bugs.map(bug =>
        bug._id === editingBug.id 
          ? { ...bug, ...newBugData }
          : bug
      ));
      setEditingBug(null);
    } else {
      // Add new bug
      //console.log("newBugData", newBugData);
      const addBugForm = async () => {

        const newBug = {
          id: Date.now(),
          ...newBugData,
          type: activeTab,
          branchID,
          personHandling: newBugData.personHandling || 'Unassigned',
          deadline: "",//newBugData.deadline || new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
          status: newBugData.status || 'Submitted',
          notes: newBugData.notes || '',
        };
        //setBugs([newBug, ...bugs]);

        const result = await creaditFbTracker(newBug, token);

        if(result.data && result.data.success){
          setBugs([result.data.data, ...bugs]);
        }
        console.log("result", result);
      };


      addBugForm()

    }
    setShowModal(false);
  };

  const handleDeleteBug = (id) => {
    if (window.confirm('Are you sure you want to delete this bug?')) {
      setBugs(bugs.filter(bug => bug._id !== id));
    }
  };

  const handleEditBug = (bugId, target, updates) => {

    console.log("updates", updates);
    console.log("bugId", bugId);
    console.log("target", target);

    const onSave = async () => {
      try {
        const dataToUpdate = { id: bugId, ...updates };
        const response = await updateFbTracker(bugId, target, dataToUpdate, token);
        console.log('Update response:', response.data);
        if (target === 'activities') {
          // Refetch all bugs to get updated activities
          const response = await getAllFbTracker(token);
          setBugs(response.data.data);
        } else {
          setBugs(bugs.map(bug =>
            bug._id === bugId 
              ? { ...bug, ...updates }
              : bug
          ));
        }

      } catch (error) {
        console.error('Error updating bug:', error);
      }
    };

    onSave();
  };

  // const uniquePeople = ['All', ...new Set(bugs.map(bug => bug.personHandling))];

  const filteredBugs = bugs
    .filter(bug => bug.type === activeTab )
    .filter(bug => selectBranch === 'All Branch' || Number(bug.branchID) === Number(selectBranch))
    .filter(bug =>  selectProject === 'All Project' || bug.project === selectProject)
    .filter(bug => {
      if (filterStatus === 'Activity') {
        return bug.status === "Submitted" || bug.status === "In Progress" || bug.status === "Checking";
      } else return bug.status === "Rejected" || bug.status === "Completed";
    })
    .filter(bug => bug.content.toLowerCase().includes(searchContent.toLowerCase()));

  return (
    <div style={{textAlign:'left', fontSize:"1.2rem", width: '100vw', height: '100vh', display: 'flex', flexDirection: 'column', margin: 0, padding: 0}}>
      <header className="border-b border-border bg-card" style={{flex: '0 0 auto'}}>
        <div style={{py: 4, px: 4}}>
          <div className="d-flex gap-3 mb-6">
            <div className="p-2 bg-primary/10 rounded-lg">
              <Bug className="w-6 h-6 text-primary" />
            </div>
            <h1 >IT Team - Bug Tracker</h1>
          </div>

          <div className="d-flex items-center gap-1">
            <button
              onClick={() => handleTabChange('feedback')}
              style={{
                width:"300px",
                height:"30px",
                fontSize:"1.2rem",
                backgroundColor: activeTab === 'feedback' ? 'yellow' : 'transparent'
              }}
            >
              <MessageSquare className="w-4 h-4 mr-2" />
              Feedback
            </button>
            <button
              onClick={() => handleTabChange('idea')}
              style={{
                width:"300px",
                height:"30px",
                fontSize:"1.2rem",
                backgroundColor: activeTab === 'idea' ? 'yellow' : 'transparent'
              }}
            >
              <Lightbulb className="w-4 h-4 mr-2" />
              Idea
            </button>
          </div>
        </div>
      </header>

      <main style={{flex: 1, overflow: 'auto', marginTop: '12px', display: 'flex', flexDirection: 'column'}}>
        <section style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
          <div className="">
            {/* <h2 className="text-xl font-semibold tracking-tight">
              {activeTab === 'feedback' ? 'Current Feedback' : 'Current Ideas'}
            </h2> */}

             <div style={{display: 'flex', flexWrap: 'wrap', gap: '1rem', marginBottom: '1rem'}}>
              <input 
                type="text"
                placeholder="Search by content..."
                value={searchContent}
                onChange={(e) => setSearchContent(e.target.value)}
                style={{
                  width: "220px",
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  fontSize: "1.2rem"
                }}
              />

              <select
                value={selectBranch}
                onChange={(e) => setSelectBranch(e.target.value)}
                style={{
                  width: "180px",
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  fontSize: "1.2rem"
                }}
              >
                {["All Branch","My Branch",].map((status) => (
                  <option key={status} value={status === "My Branch" ? branchID : status}>{status}</option>
                ))}
              </select>

              <select
                value={selectProject}
                onChange={(e) => setSelectProject(e.target.value)}
                style={{
                  width: "180px",
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  fontSize: "1.2rem"
                }}
              >
                {["All Project","Database", "Report", "Mail", "Web", "Application", "Idea", "Other"].map((status) => (
                  <option key={status} value={status}>{status}</option>
                ))}
              </select>

              <select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                style={{
                  width: "180px",
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  fontSize: "1.2rem"
                }}
              >
                {
                //["All Status","Submitted", "In Progress", "Rejected","Checking", "Completed"]
                ["Activity", "Complete / Remove"].map((status) => (
                  <option key={status} value={status}>{status}</option>
                ))}
              </select>

              <button
                onClick={() => {
                  setSearchContent('');
                  setFilterStatus('Activity');
                  setSelectProject('All Project');
                  setSelectBranch('All Branch');
                }}
                style={{
                  padding: "8px 16px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  backgroundColor: "#f0f0f0",
                  cursor: "pointer",
                  fontSize: "1.2rem"
                }}
              >
                Clear Filters
              </button>

            <button
              onClick={() => setShowModal(true)}
              style={{
                padding: "10px 20px",
                borderRadius: "4px",
                border: "none",
                backgroundColor: "#4CAF50",
                color: "white",
                cursor: "pointer",
                fontSize: "1.2rem",
                fontWeight: "bold"
              }}
            >
              + Add {activeTab === 'feedback' ? 'Feedback' : 'Idea'}
            </button>
            </div>
          </div>
          <div style={{fontStyle:"italic",fontWeight:"600"}}>* Tips: Add email title / emails address / link error with Autobooking / Database issues. ( Thêm các tiêu đề / mail / link lỗi với các vấn đề Autobooking / Database )</div>
          <div className="mb-2" style={{fontSize:"1.2rem", display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            {/* <span>* Showing {filteredBugs.length} of {bugs.length} issues</span> */}

          </div>
          <div style={{flex: 1, overflow: 'auto'}}>
           <BugTable 
              bugs={filteredBugs} 
              onSaveAddActivity={onSaveAddActivity}
              onStatusChange={handleStatusChange}
              onEdit={handleEditBug}
              onDelete={handleDeleteBug}
            />
          </div>
        </section>
      </main>
      {/* Tab Change Warning Modal */}
      {showTabWarning && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1100
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '30px',
            maxWidth: '400px',
            width: '90%',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}>
            <h2 style={{margin: '0 0 15px 0', fontSize: '1.3rem', color: '#2c3e50'}}>
              Unsaved Changes
            </h2>
            <p style={{margin: '0 0 20px 0', fontSize: '1rem', color: '#555'}}>
              You have unsaved data. Do you want to add this {activeTab === 'feedback' ? 'Feedback' : 'Idea'} before switching tabs?
            </p>
            <div style={{display: 'flex', gap: '10px', justifyContent: 'flex-end'}}>
              <button
                onClick={() => {
                  setShowTabWarning(false);
                  setPendingTab(null);
                }}
                style={{
                  padding: '10px 20px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  backgroundColor: '#f0f0f0',
                  cursor: 'pointer',
                  fontSize: '1.1rem',
                  fontWeight: '500'
                }}
              >
                Keep Editing
              </button>
              <button
                onClick={() => {
                  setShowTabWarning(false);
                  setShowModal(false);
                  setEditingBug(null);
                  if (pendingTab) {
                    setActiveTab(pendingTab);
                  }
                  setPendingTab(null);
                }}
                style={{
                  padding: '10px 20px',
                  borderRadius: '4px',
                  border: 'none',
                  backgroundColor: '#e74c3c',
                  color: 'white',
                  cursor: 'pointer',
                  fontSize: '1rem',
                  fontWeight: '500'
                }}
              >
                Discard
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Modal */}
      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '30px',
            maxWidth: '600px',
            width: '90%',
            maxHeight: '90vh',
            overflow: 'auto',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
              <h2 style={{margin: 0, fontSize: '1.5rem'}}>
                {editingBug ? 'Edit' : 'Add New'} {activeTab === 'feedback' ? 'Feedback' : 'Idea'}
              </h2>
              <button
                onClick={() => {
                  setShowModal(false);
                  setEditingBug(null);
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#999'
                }}
              >
                ✕
              </button>
            </div>
            <AddBugForm 
              onAddBug={handleAddBug} 
              type={activeTab}
              initialData={editingBug}
            />
          </div>
        </div>
      )}

    </div>
  );
}

export default FeddbackErrorContainer;
